var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoadingLocal)?_c('Loader',{class:{ 'is-absolutePositioned': _vm.absolutePosition }}):_vm._t("default",null,{"isLoading":_vm.isLoadingLocal,"hasError":!!_vm.error,"error":_vm.error})],2)}
var staticRenderFns = []

export { render, staticRenderFns }